module.exports = new __parcel__URL__("game-engine-black-book-doom.ab3da887.jpg").toString();